import type { ListResult } from "@prolarus/shared";
import { tryList } from "./_shared";

export interface UserGroupMembership {
  group_id: string;
  group_name: string;
  group_description: string | null;
  is_active: boolean;
}

// _companyId is preserved for signature compatibility; the route clamps
// company_id from the JWT.
export const userGroupService = {
  getUserGroups(
    profileId: string,
    _companyId: string,
  ): Promise<ListResult<UserGroupMembership>> {
    return tryList<UserGroupMembership>(
      `/api/profiles/${encodeURIComponent(profileId)}/groups`,
    );
  },
};
